// // src/components/LoginPage.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../config";

function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const response = await fetch(`${API_BASE_URL}/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

      if (response.ok) {
        const data = await response.json();

        localStorage.setItem("user_id", data.user_id);
        localStorage.setItem("username", data.username);
        localStorage.setItem("access_level", data.access_level);
        localStorage.setItem("email", data.email);

        navigate("/");
      } else {
        setError("Invalid email or password");
      }
    } catch (err) {
      setError("Something went wrong. Please try again.");
    }
  };

  return (
    <div className="min-h-screen bg-slate-900 flex items-center justify-center px-4">
      <div className="w-full max-w-sm bg-slate-950 border border-slate-800 rounded-xl shadow-xl p-6">

        {/* LOGO */}
        <div className="flex justify-center mb-4">
          <img
            src="https://storage.googleapis.com/rgw-public/logo-02.png"
            alt="Logo"
            className="h-12"
          />
        </div>

        {/* HEADER */}
        <h1 className="text-xl font-semibold text-center text-slate-100">
          Sign in
        </h1>
        <p className="text-sm text-slate-400 text-center mb-6">
          Access your chatbot dashboard
        </p>

        {/* ERROR */}
        {error && (
          <div className="mb-4 text-sm text-red-400 bg-red-500/10
                          border border-red-500/30 rounded-lg px-3 py-2">
            {error}
          </div>
        )}

        {/* FORM */}
        <form onSubmit={handleLogin} className="space-y-4">

          <div>
            <label className="block text-xs text-slate-400 mb-1">
              Email
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@company.com"
              required
              className="w-full rounded-lg bg-slate-800 border border-slate-700
                         px-3 py-2 text-sm text-slate-100
                         focus:ring-2 focus:ring-emerald-500 outline-none"
            />
          </div>

          <div>
            <label className="block text-xs text-slate-400 mb-1">
              Password
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              required
              className="w-full rounded-lg bg-slate-800 border border-slate-700
                         px-3 py-2 text-sm text-slate-100
                         focus:ring-2 focus:ring-emerald-500 outline-none"
            />
          </div>

          <button
            type="submit"
            className="w-full mt-2 rounded-lg bg-emerald-500 text-slate-900
                       py-2 text-sm font-semibold
                       hover:bg-emerald-400 transition"
          >
            Login
          </button>
        </form>

        {/* FOOTER */}
        <p className="text-[11px] text-slate-500 text-center mt-6">
          © {new Date().getFullYear()} Wiom • Internal Access
        </p>
      </div>
    </div>
  );
}

export default LoginPage;
